import { CurrentUser } from 'Roblox';
import { localStorageService } from 'core-roblox-utilities';

type TCache<T> = {
  data: T;
  userId: string;
  time: number;
};

export const cacheApi = async <T>(
  key: string,
  api: () => Promise<T>,
  validate: (cache: TCache<T>) => boolean
): Promise<T> => {
  let cache: null | TCache<T> = null;
  try {
    cache = localStorageService.getLocalStorage(key) as null | TCache<T>;
  } catch {
    cache = null;
  }

  // NOTE (09/22/21, jcountryman): Cache is only valid if it belongs to the same user
  if (cache !== null && cache.userId === CurrentUser.userId && validate(cache)) {
    return cache.data;
  }

  const data = await api();
  localStorageService.setLocalStorage(key, {
    data,
    userId: CurrentUser.userId || 'guest',
    time: new Date().getTime()
  });

  return data;
};

export default { cacheApi };
